import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Dashboard from '@/components/Dashboard'
import Bulkbooking from '@/components/Bulkbooking'
import Wynumtrack from '@/components/Wynumtrack'
import Trackbookingno from '@/components/Trackbookingno'
import Overviewmanifest from '@/components/Overviewmanifest'
import Shippinginstructionsoverview from '@/components/Shippinginstructionsoverview'
import Shippinginstructionsdocument from '@/components/Shippinginstructionsdocument'
import Dailyfullloadreport from '@/components/Dailyfullloadreport'
import Emptycontainerreport from '@/components/Emptycontainerreport'
import Onholdreport from '@/components/Onholdreport'
import Settings from '@/components/Settings'
import Addressbook from '@/components/Addressbook'
import Addressbulkupload from '@/components/Addressbulkupload'
import Mybookings from '@/components/Mybookings'
import Freightforwardingbookingform from '@/components/Freightforwardingbookingform'
import Customclearancebookingform from '@/components/Customclearancebookingform'
import Warehousemanagement from '@/components/Warehousemanagement'
import Transportplan from '@/components/Transportplan'
import Hubmanagement from '@/components/Hubmanagement'
import Trackyourshipment from '@/components/Trackyourshipment'
import Truckingaddregions from '@/components/Truckingaddregions'
import Truckingaddcities from '@/components/Truckingaddcities'
import Truckingservicelocation from '@/components/Truckingservicelocation'
import Truckingthirdpartytransporters from '@/components/Truckingthirdpartytransporters'
import Truckingaccountedcustomers from '@/components/Truckingaccountedcustomers'
import Truckingemployees from '@/components/Truckingemployees'
import Truckingaddnewtruck from '@/components/Truckingaddnewtruck'
import Truckingalltrucksreport from '@/components/Truckingalltrucksreport'
import Truckingpickuprequest from '@/components/Truckingpickuprequest'
import Truckingaccountedcustomerreport from '@/components/Truckingaccountedcustomerreport'
import Truckingservicelocationreport from '@/components/Truckingservicelocationreport'
import Truckingcitiesreport from '@/components/Truckingcitiesreport'
import Truckingemployeesreport from '@/components/Truckingemployeesreport'
import Truckingregionsreport from '@/components/Truckingregionsreport'
import Transportationinbounddelivery from '@/components/Transportationinbounddelivery'
import Transportationinboundreport from '@/components/Transportationinboundreport'
import Transportationoutbounddelivery from '@/components/Transportationoutbounddelivery'
import Transportationtrip from '@/components/Transportationtrip'
import Transportationtripreport from '@/components/Transportationtripreport'
import Transportationinbounddispatch from '@/components/Transportationinbounddispatch'
import Transportationinbounddispatchreport from '@/components/Transportationinbounddispatchreport'
import Transportationoutbounddispatch from '@/components/Transportationoutbounddispatch'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/bulkbooking',
      name: 'Bulkbooking',
      component: Bulkbooking
    },
    {
      path: '/wynumtrack',
      name: 'Wynumtrack',
      component: Wynumtrack
    },
    {
      path: '/trackbookingno',
      name: 'Trackbookingno',
      component: Trackbookingno
    },
    {
      path: '/overviewmanifest',
      name: 'Overviewmanifest',
      component: Overviewmanifest
    },
    {
      path: '/shippinginstructionsoverview',
      name: 'Shippinginstructionsoverview',
      component: Shippinginstructionsoverview
    },
    {
      path: '/shippinginstructionsdocument',
      name: 'Shippinginstructionsdocument',
      component: Shippinginstructionsdocument
    },
    {
      path: '/dailyfullloadreport',
      name: 'Dailyfullloadreport',
      component: Dailyfullloadreport
    },
    {
      path: '/emptycontainerreport',
      name: 'Emptycontainerreport',
      component: Emptycontainerreport
    },
    {
      path: '/onholdreport',
      name: 'Onholdreport',
      component: Onholdreport
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/addressbook',
      name: 'Addressbook',
      component: Addressbook
    },
    {
      path: '/addressbulkupload',
      name: 'Addressbulkupload',
      component: Addressbulkupload
    },
    {
      path: '/mybookings',
      name: 'Mybookings',
      component: Mybookings
    },
    {
      path: '/freightforwardingbookingform',
      name: 'Freightforwardingbookingform',
      component: Freightforwardingbookingform
    },
    {
      path: '/customclearancebookingform',
      name: 'Customclearancebookingform',
      component: Customclearancebookingform
    },
    {
      path: '/warehousemanagement',
      name: 'Warehousemanagement',
      component: Warehousemanagement
    },
    {
      path: '/transportplan',
      name: 'Transportplan',
      component: Transportplan
    },
    {
      path: '/hubmanagement',
      name: 'Hubmanagement',
      component: Hubmanagement
    },
    {
      path: '/trackyourshipment',
      name: 'Trackyourshipment',
      component: Trackyourshipment
    },
    {
      path: '/truckingaddregions',
      name: 'Truckingaddregions',
      component: Truckingaddregions
    },
    {
      path: '/truckingaddcities',
      name: 'Truckingaddcities',
      component: Truckingaddcities
    },
    {
      path: '/truckingservicelocation',
      name: 'Truckingservicelocation',
      component: Truckingservicelocation
    },
    {
      path: '/truckingthirdpartytransporters',
      name: 'Truckingthirdpartytransporters',
      component: Truckingthirdpartytransporters
    },
    {
      path: '/truckingaccountedcustomers',
      name: 'Truckingaccountedcustomers',
      component: Truckingaccountedcustomers
    },
    {
      path: '/truckingemployees',
      name: 'Truckingemployees',
      component: Truckingemployees
    },
    {
      path: '/truckingaddnewtruck',
      name: 'Truckingaddnewtruck',
      component: Truckingaddnewtruck
    },
    {
      path: '/truckingalltrucksreport',
      name: 'Truckingalltrucksreport',
      component: Truckingalltrucksreport
    },
    {
      path: '/truckingpickuprequest',
      name: 'Truckingpickuprequest',
      component: Truckingpickuprequest
    },
    {
      path: '/truckingaccountedcustomerreport',
      name: 'Truckingaccountedcustomerreport',
      component: Truckingaccountedcustomerreport
    },
    {
      path: '/truckingservicelocationreport',
      name: 'Truckingservicelocationreport',
      component: Truckingservicelocationreport
    },
    {
      path: '/truckingcitiesreport',
      name: 'Truckingcitiesreport',
      component: Truckingcitiesreport
    },
    {
      path: '/truckingemployeesreport',
      name: 'Truckingemployeesreport',
      component: Truckingemployeesreport
    },
    {
      path: '/truckingregionsreport',
      name: 'Truckingregionsreport',
      component: Truckingregionsreport
    },
    {
      path: '/transportationinbounddelivery',
      name: 'Transportationinbounddelivery',
      component: Transportationinbounddelivery
    },
    {
      path: '/transportationinboundreport',
      name: 'Transportationinboundreport',
      component: Transportationinboundreport
    },
    {
      path: '/transportationoutbounddelivery',
      name: 'Transportationoutbounddelivery',
      component: Transportationoutbounddelivery
    },
    {
      path: '/transportationtrip',
      name: 'Transportationtrip',
      component: Transportationtrip
    },
    {
      path: '/transportationtripreport',
      name: 'Transportationtripreport',
      component: Transportationtripreport
    },
    {
      path: '/transportationinbounddispatch',
      name: 'Transportationinbounddispatch',
      component: Transportationinbounddispatch
    },
    {
      path: '/transportationinbounddispatchreport',
      name: 'Transportationinbounddispatchreport',
      component: Transportationinbounddispatchreport
    },
    {
      path: '/Transportationoutbounddispatch',
      name: 'Transportationoutbounddispatch',
      component: Transportationoutbounddispatch
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js